import { PropsWithChildren } from 'react';

import { CircularProgress, Fade, Stack, Typography } from '@mui/material';
import { Spinner } from '@natter-co/design-system';
import { useInheritedVisualRefresh } from 'common/theme';

export type LoadingProps = {
  label: string;
  isLoading?: boolean;
  text?: string;
};

export const Loading = ({ label, isLoading = true, text, children }: PropsWithChildren<LoadingProps>) => {
  const visualRefresh = useInheritedVisualRefresh();

  if (!isLoading && children) return <>{children}</>;

  if (visualRefresh) {
    return (
      <div className="flex h-full items-center justify-center" data-testid="loading-container">
        <Spinner label={label} showLabel size="xl" delayed />
      </div>
    );
  }

  return (
    <Fade in unmountOnExit>
      <Stack justifyContent="center" alignItems="center" height={1} gap={2} data-testid="loading-container">
        <CircularProgress />
        {text && <Typography variant="natter-display-sm">{text}</Typography>}
      </Stack>
    </Fade>
  );
};
